
import React from 'react';
import { FormControlLabel, Switch as MaterialSwitch, SwitchProps as MuiSwitchProps } from '@material-ui/core';
import Field, { FieldProps } from './Field';

const Switch = <T, >({ label, value, error, ...other }: SwitchProps<T>) => {
    return (
        <FormControlLabel
            checked={value as boolean}
            control={<MaterialSwitch color="primary" value={value} {...other} />}
            label={label}
        />
    );
};

type SwitchProps<T> = Omit<FieldProps<T, MuiSwitchProps>, 'renderer'> & {
    label?: string;
    error?: string;
};

// @ts-ignore - Field need more proper typing
const SwitchField = <T, >(props: SwitchProps<T>) => <Field {...props} renderer={Switch} />;

export default SwitchField;
